import React from 'react';
import PropTypes from 'prop-types';

import { useFetchStatus } from '../../../../../../utils/fetchStatusUtils';
import CashbackPresenter from '../../../../../../presenters/CashbackPresenter';
import ListSkeleton from '../../../../../../components/Skeletons/ListSkeleton';
import Pagination from '../../../../../../components/Pagination';

import Cashback from './components/Cashback';

const CashbacksTable = (props) => {
  const { cashbacks, loadingState, meta, onPageChange } = props;

  const { isFulfilled } = useFetchStatus(loadingState);

  if (!isFulfilled) {
    return <ListSkeleton height={15} width={500} />;
  }

  const isCashbacksEmpty = cashbacks.length === 0;

  if (isCashbacksEmpty) {
    return <div className="empty-table">No data for selected parameters</div>;
  }

  return (
    <div>
      <table className="tables">
        <thead>
          <tr>
            <th>Date</th>
            <th>Store Name</th>
            <th>Amount</th>
            <th>Rate</th>
            <th>State</th>
            <th>Transaction Amount</th>
          </tr>
        </thead>
        <tbody>
          {cashbacks.map((cashback, index, cashbacks) => {
            const previousCashback = cashbacks[index - 1];
            return (
              <Cashback
                key={cashback.id}
                cashback={cashback}
                previousCashback={previousCashback}
              />
            );
          })}
        </tbody>
      </table>
      <Pagination meta={meta} onPageChange={onPageChange} />
    </div>
  );
};

export default CashbacksTable;

CashbacksTable.propTypes = {
  cashbacks: PropTypes.arrayOf(CashbackPresenter.shape()),
  meta: PropTypes.shape().isRequired,
  onPageChange: PropTypes.func.isRequired,
  loadingState: PropTypes.string.isRequired,
};

CashbacksTable.defaultProps = {
  cashbacks: [],
};
